import React from 'react';

import styled from 'styled-components';
import moment from 'moment';
import SweetAlert from '../../shared/SweetAlert';
import Swal from 'sweetalert2';
import update from 'immutability-helper';

import * as actionTypes from './actionTypes';
import { Fetcher } from '../helpers';
import { TileManager } from '../../containers/clientAdminTiles/utils';
import { TileDigestCalendar } from '../../containers/clientAdminTiles/components/TileDigestCalendar.jsx';
import { hideTileView } from './tileView/tileViewSlice';
import i18n from '../../app/i18n';
import { setNotification } from './notification/notificationSlice';

import helper from '../../containers/clientAdminTiles/utils/helpers';

const tileStatus = ({ ignored, status }) =>
  ignored ? 'user_submitted' : status;

const DeleteTopicSubtitle = styled.div`
  line-height: 28px !important;
`;

export const setUserData = content => ({
  type: actionTypes.SET_USER_DATA,
  payload: { ...content },
});

export const addTilesToStore = tiles => ({
  type: actionTypes.ADD_TILES_TO_STORE,
  payload: { ...tiles },
});

export const setDemoData = demo => ({
  type: actionTypes.SET_DEMO_DATA,
  payload: { ...demo },
});

export const setOrganizationData = organization => ({
  type: actionTypes.SET_ORGANIZATION_DATA,
  payload: { ...organization },
});

export const setProgressBarData = data => ({
  type: actionTypes.SET_PROGRESS_BAR_DATA,
  payload: { ...data },
});

export const setTilesPerRow = data => ({
  type: actionTypes.SET_TILES_PER_ROW,
  payload: data,
});

export const setActiveStatus = data => ({
  type: actionTypes.SET_ACTIVE_STATUS,
  payload: data,
});

export const setIsUserSiteAdmin = data => ({
  type: actionTypes.SET_IS_USER_SITE_ADMIN,
  payload: data,
});

export const setAlert = data => ({
  type: actionTypes.SET_ALERT,
  payload: data,
});

export const setFilters = data => ({
  type: actionTypes.SET_FILTERS,
  payload: data,
});

export const setAudiences = data => ({
  type: actionTypes.SET_AUDIENCES,
  payload: data,
});

export const addAudience = data => ({
  type: actionTypes.ADD_AUDIENCE,
  payload: data,
});

export const addTopic = data => ({
  type: actionTypes.ADD_TOPIC,
  payload: data,
});

export const removeAudience = data => ({
  type: actionTypes.REMOVE_AUDIENCE,
  payload: data,
});

export const removeTopic = data => ({
  type: actionTypes.REMOVE_TOPIC,
  payload: data,
});

export const setTopics = data => ({
  type: actionTypes.SET_TOPICS,
  payload: data,
});

export const setPopulationSegments = data => ({
  type: actionTypes.SET_POPULATION_SEGMENTS,
  payload: data,
});

export const setEditDate = data => ({
  type: actionTypes.SET_EDIT_DATE,
  payload: data,
});

export const setBuckets = data => ({
  type: actionTypes.SET_BUCKETS,
  payload: data,
});

export const updateBucketTiles = data => ({
  type: actionTypes.UPDATE_BUCKET_TILES,
  payload: data,
});

export const setTiles = data => ({
  type: actionTypes.SET_TILES,
  payload: data,
});

export const setDragAndDropContext = data => ({
  type: actionTypes.SET_DRAG_AND_DROP_CONTEXT,
  payload: data,
});

export const initializeDragAndDropContext = data => ({
  type: actionTypes.INITIALIZE_DRAG_AND_DROP_CONTEXT,
  payload: data,
});

export const setTileCopy = data => ({
  type: actionTypes.COPY_TILE,
  payload: data,
});

export const removeTile = data => ({
  type: actionTypes.REMOVE_TILE,
  payload: data,
});

export const removeTiles = data => ({
  type: actionTypes.REMOVE_TILES,
  payload: data,
});

export const toggleTileLoading = data => ({
  type: actionTypes.TOGGLE_TILE_LOADING,
  payload: data,
});

export const updateTile = data => ({
  type: actionTypes.UPDATE_TILE,
  payload: data,
});

export const moveTilesToState = data => ({
  type: actionTypes.MOVE_TILES_TO_STATE,
  payload: data,
});

export const toggleTileIgnore = data => ({
  type: actionTypes.TOGGLE_TILE_IGNORE,
  payload: data,
});

export const setClients = data => ({
  type: actionTypes.SET_CLIENTS,
  payload: data,
});

export const addClient = data => ({
  type: actionTypes.ADD_CLIENT,
  payload: data,
});

export const getClients = (page = 1, direction = '', sort_by = '') => {
  return dispatch => {
    const request = Fetcher.xmlHttpRequest({
      method: 'GET',
      path: `/api/client_admin/clients?page=${page}&direction=${direction}&sort_by=${sort_by}`,
    });

    return request.then(response => {
      dispatch(setClients(response));
    });
  };
};

export const updateDragAndDropContext = () => {
  return (dispatch, getState) => {
    const {
      tiles,
      status: { activeStatus },
      tilesPerRow,
    } = getState();

    const dragAndDropParams = {
      tiles: tiles.tiles,
      activeStatus,
      tilesPerRow,
      buckets: tiles.buckets,
    };
    dispatch(initializeDragAndDropContext(dragAndDropParams));
  };
};

export const editTile = ({ id, ignored, status, planDate, editPath }) => {
  return dispatch => {
    const activeStatus = tileStatus({ id, ignored, status });
    dispatch(toggleTileLoading({ tileId: id, activeStatus }));

    const tileForm = window.Airbo.TileFormModal;

    tileForm.init(window.Airbo.TileManager);
    window.Airbo.TileManager.planDate =
      planDate !== null ? moment(planDate).toDate() : null;
    tileForm.open(editPath);

    dispatch(toggleTileLoading({ tileId: id, activeStatus }));
  };
};

export const moveTilesToProof = (tilesIds, bucketDate) => {
  return (dispatch, getState) => {
    tilesIds.forEach(tileId =>
      dispatch(toggleTileLoading({ tileId, activeStatus: 'plan' })),
    );

    const request = Fetcher.xmlHttpRequest({
      method: 'POST',
      path: `/api/client_admin/tiles/update_status`,
      params: { ids: tilesIds, value: 'draft' },
    });

    return request
      .then(response => {
        const { tiles } = getState();
        const { status, headline } = response[0];
        let title = i18n.t('edit:tileStatusNotifications.singleTileTitle', {
          status,
        });
        let content = i18n.t('edit:tileStatusNotifications.singleTileContent', {
          headline,
        });

        if (bucketDate) {
          dispatch(removeDigest(bucketDate));

          title = i18n.t('edit:tileStatusNotifications.multipleTileTitle', {
            status,
          });

          content = i18n.t('edit:tileStatusNotifications.multipleTileContent', {
            number: response.length,
          });
        }

        dispatch(
          moveTilesToState({
            response,
            tilesIds,
            currentState: 'plan',
            newState: 'draft',
          }),
        );
        dispatch(updateDragAndDropContext());

        window.Airbo.PubSub.publish('updateShareTabNotification', {
          number: tiles.tiles.draft.count,
        });

        dispatch(
          setNotification({
            variant: 'success',
            title,
            content,
            disappear: true,
          }),
        );
      })
      .catch(() => {
        tilesIds.forEach(tileId =>
          dispatch(toggleTileLoading({ tileId, activeStatus: 'plan' })),
        );

        dispatch(
          setNotification({
            variant: 'error',
            content: i18n.t('edit:tileStatusNotifications.error'),
            disappear: true,
          }),
        );
      });
  };
};

export const moveTiles = (tilesIds, prevStatus, newStatus) => {
  return (dispatch, getState) => {
    if (!tilesIds.length) return;

    tilesIds.forEach(tileId =>
      dispatch(toggleTileLoading({ tileId, activeStatus: prevStatus })),
    );

    const request = Fetcher.xmlHttpRequest({
      method: 'POST',
      path: `/api/client_admin/tiles/update_status`,
      params: { ids: tilesIds, value: newStatus },
    });

    return request.then(response => {
      dispatch(
        moveTilesToState({
          response: response,
          tilesIds: tilesIds,
          currentState: prevStatus,
          newState: newStatus,
        }),
      );

      const { tiles } = getState();

      dispatch(generateBuckets(tiles.tiles.active.tiles));
      dispatch(updateDragAndDropContext());

      window.Airbo.PubSub.publish('updateShareTabNotification', {
        number: tiles.tiles.draft.count,
      });
    });
  };
};

export const copyTile = ({ id, ignored, status }) => {
  return dispatch => {
    const activeStatus = tileStatus({ ignored, status });
    dispatch(toggleTileLoading({ tileId: id, activeStatus }));

    const request = Fetcher.xmlHttpRequest({
      method: 'POST',
      path: `/api/client_admin/tiles/${id}/copy_tile`,
    });

    return request
      .then(response => {
        dispatch(hideTileView());
        dispatch(setTileCopy({ tile: response[0] }));
        dispatch(toggleTileLoading({ tileId: id, activeStatus }));
        dispatch(updateDragAndDropContext());
      })
      .catch(() => {
        dispatch(
          setNotification({
            variant: 'error',
            content: i18n.t('edit:tileStatusNotifications.error'),
            disappear: true,
          }),
        );
        window.location.reload();
      });
  };
};

export const triggerDeleteModal = ({ ignored, status, id }) => {
  return dispatch => {
    const args = {
      customClass: 'airbo',
      cancelBtnCssClass: 'cancel-v2',
      confirmBtnCssClass: 'delete_confirm-v2',
      confirmBtnText: 'Delete',
      showCancel: true,
      style: {
        display: 'inherit',
        width: '520px',
      },
      title: "Deleting a Tile can't be undone",
      text: 'Are you sure you want to delete this Tile?',
      onCancel: () => {
        dispatch(setAlert(null));
      },
      onConfirm: () => {
        dispatch(hideTileView());
        dispatch(deleteTile({ ignored, status, id }));
        dispatch(setAlert(null));
      },
    };
    const alert = <SweetAlert {...args}>{args.text}</SweetAlert>;

    dispatch(setAlert(alert));
  };
};

export const deleteTile = ({ ignored, status, id }) => {
  return (dispatch, getState) => {
    const { tiles } = getState().tiles.tiles.plan;
    const deletedTile = tiles.find(tile => tile.id === id);

    dispatch(
      toggleTileLoading({
        tileId: id,
        activeStatus: tileStatus({ ignored, status }),
      }),
    );

    const request = Fetcher.xmlHttpRequest({
      method: 'DELETE',
      path: `/api/client_admin/tiles/destroy_tiles`,
      params: { ids: id },
    });

    return request.then(() => {
      dispatch(removeTile({ ignored, status, id }));
      dispatch(updateDragAndDropContext());
      dispatch(
        setNotification({
          variant: 'delete',
          content: i18n.t('edit:tileStatusNotifications.deleteTile', {
            headline: deletedTile.headline,
          }),
          title: i18n.t('edit:tileStatusNotifications.delete'),
          disappear: true,
        }),
      );
    });
  };
};

export const deleteTiles = (tiles, status, bucketDate) => {
  return dispatch => {
    const tilesIds = tiles.map(tile => tile.id);

    const request = Fetcher.xmlHttpRequest({
      method: 'DELETE',
      path: `/api/client_admin/tiles/destroy_tiles`,
      params: { ids: tilesIds },
    });

    return request.then(() => {
      dispatch(removeTiles({ tilesIds, status }));
      if (bucketDate) {
        dispatch(removeDigest(bucketDate));
      }
      dispatch(updateDragAndDropContext());
    });
  };
};

export const acceptTile = ({ id, ignored, status }) => {
  return dispatch => {
    const tilesIds = [id];
    const activeStatus = tileStatus({ ignored, status });
    dispatch(
      toggleTileLoading({
        tileId: id,
        activeStatus,
      }),
    );

    const request = Fetcher.xmlHttpRequest({
      method: 'POST',
      path: `/api/client_admin/tiles/update_status`,
      params: { ids: tilesIds, value: 'plan' },
    });

    return request.then(response => {
      dispatch(hideTileView());
      dispatch(toggleTileLoading({ tileId: id, activeStatus }));
      dispatch(
        moveTilesToState({
          response,
          tilesIds,
          currentState: 'user_submitted',
          newState: 'plan',
        }),
      );
      dispatch(updateDragAndDropContext());
    });
  };
};

export const ignoreTile = ({ tileId }) => {
  return dispatch => {
    dispatch(toggleTileLoading({ tileId, activeStatus: 'user_submitted' }));

    const request = Fetcher.xmlHttpRequest({
      method: 'PUT',
      path: `/api/client_admin/tiles/${tileId}`,
      params: { newStatus: 'ignored' },
    });

    return request.then(() => {
      dispatch(hideTileView());
      dispatch(toggleTileIgnore({ tileId, activeStatus: 'user_submitted' }));
      dispatch(toggleTileLoading({ tileId, activeStatus: 'user_submitted' }));
      dispatch(updateDragAndDropContext());
    });
  };
};

export const undoIgnoreTile = ({ id, ignored, status }) => {
  return dispatch => {
    dispatch(
      toggleTileLoading({
        tileId: id,
        activeStatus: tileStatus({ ignored, status }),
      }),
    );

    const request = Fetcher.xmlHttpRequest({
      method: 'PUT',
      path: `/api/client_admin/tiles/${id}`,
      params: { newStatus: 'user_submitted' },
    });

    return request.then(() => {
      dispatch(
        toggleTileIgnore({ tileId: id, activeStatus: 'user_submitted' }),
      );
      dispatch(
        toggleTileLoading({ tileId: id, activeStatus: 'user_submitted' }),
      );
      dispatch(updateDragAndDropContext());
    });
  };
};

export const addTileToDigest = bucketDate => {
  return () => {
    const url = '/client_admin/tiles/new';
    const tileForm = window.Airbo.TileFormModal;
    window.Airbo.TileManager.planDate = bucketDate !== null ? bucketDate : null;
    tileForm.init(window.Airbo.TileManager);
    tileForm.open(url);
  };
};

export const showDigestCalendar = bucketDate => {
  return (dispatch, getState) => {
    let newDate =
      getState().editPage.editDate ||
      bucketDate
        .replace(' - ', '')
        .split('-')
        .reverse()
        .join('-');

    const DigestCalendar = () =>
      React.createElement(TileDigestCalendar, {
        subHeader: 'Select a new date for the Tile Digest',
        value: newDate,
        onChange: value => {
          dispatch(setEditDate(value));
        },
        onConfirm: () => {
          newDate = getState().editPage.editDate;

          dispatch(setAlert(null));
          dispatch(
            editDigest(
              bucketDate,
              newDate
                .replace(' - ', '')
                .split('-')
                .reverse()
                .join('-'),
            ),
          );
          dispatch(setEditDate(null));
        },
        onCancel: () => {
          dispatch(setAlert(null));
          dispatch(setEditDate(null));
        },
      });

    const alertContent = DigestCalendar({
      initialDate: moment(bucketDate).toDate(),
      minDate: moment(),
    });

    const alert = <div>{alertContent}</div>;

    dispatch(setAlert(alert));
  };
};

const updateBuckets = (buckets, month, bucketDate) => {
  if (buckets[month]) {
    const digests = buckets[month].digests;
    const digestCount = Object.keys(digests).length;
    const tileCount = Object.entries(digests).reduce(
      (acc, digest) =>
        digest[0] === bucketDate ? acc : acc + digest[1].tiles.length,
      0,
    );

    return update(buckets, {
      [month]: {
        digests: {
          $unset: [bucketDate],
        },
        digestCount: {
          $set: digestCount - 1,
        },
        tileCount: {
          $set: tileCount,
        },
      },
    });
  }

  return buckets;
};

const updateBucketDate = (buckets, bucketDate, targetDate) => {
  const bucketMonth = moment(bucketDate).format('YYYY-MM');
  const bucket = buckets[bucketMonth];
  const digest = bucket.digests[bucketDate];
  const updatedBuckets = update(buckets, {
    [bucketMonth]: {
      digests: {
        $unset: [bucketDate],
      },
    },
  });

  return update(updatedBuckets, {
    [bucketMonth]: {
      digests: {
        $merge: {
          [targetDate]: digest,
        },
      },
    },
  });
};

const findBucketMonth = bucketDate => {
  return moment(bucketDate, 'YYYY-MM-DD').format('YYYY-MM');
};

const updateTilesPlanDate = (bucketDate, targetDate) => {
  return (dispatch, getState) => {
    const {
      tiles: { tiles, buckets },
      status: { activeStatus },
    } = getState();
    const currentTiles = tiles[activeStatus].tiles.filter(
      tile => tile.planDate === bucketDate,
    );
    const idsToChange = currentTiles.map(tile => tile.id);
    const request = Fetcher.xmlHttpRequest({
      method: 'POST',
      path: `/api/client_admin/tiles/update_plan_date`,
      params: { ids: idsToChange, value: targetDate },
    });

    return request.then(response => {
      const newBucketMonth = targetDate ? findBucketMonth(targetDate) : null;
      const tilesToUpdate = tiles[activeStatus].tiles
        .filter(tile => idsToChange.includes(tile.id))
        .sort((a, b) => b.position - a.position)
        .map(tile => {
          const updatedItem = response.find(
            attributes => attributes.tile.uuid === tile.id,
          );
          const updatedTile = updatedItem.tile;

          return {
            ...tile,
            bucketMonth: newBucketMonth,
            planDate: updatedTile.plan_date,
            position: updatedTile.position,
          };
        });
      const filteredTiles = tiles[activeStatus].tiles.filter(
        tile => !idsToChange.includes(tile.id),
      );
      const updatedTiles = tilesToUpdate.concat(filteredTiles);
      const updatedBuckets = updateBucketDate(buckets, bucketDate, targetDate);
      const newTiles = update(tiles, {
        [activeStatus]: { tiles: { $set: updatedTiles } },
      });

      dispatch(setTiles(newTiles));

      if (targetDate) {
        dispatch(setBuckets(updatedBuckets));
      } else {
        dispatch(removeDigest(bucketDate));
      }

      dispatch(updateDragAndDropContext(newTiles));
    });
  };
};

export const editDigest = (bucketDate, targetDate) => {
  return (dispatch, getState) => {
    const {
      tiles: { tiles, buckets },
      status: { activeStatus },
    } = getState();
    const bucketMonth = moment(bucketDate).format('YYYY-MM');
    const digest = buckets[bucketMonth]['digests'][bucketDate];

    if (digest && digest.tiles.length === 0) {
      const bucketsWithoutBucketDate = update(buckets, {
        [bucketMonth]: {
          digests: {
            $unset: [bucketDate],
          },
        },
      });
      const newBuckets = update(bucketsWithoutBucketDate, {
        [bucketMonth]: {
          digests: {
            $merge: {
              [targetDate]: { tiles: [] },
            },
          },
        },
      });

      dispatch(setBuckets(newBuckets));

      return dispatch(updateDragAndDropContext());
    }

    const existingTileDigestDates = Object.keys(
      TileManager.groupBy(tiles[activeStatus].tiles, 'planDate'),
    );
    const newTileDigest = !existingTileDigestDates.includes(targetDate);

    if (newTileDigest) {
      return dispatch(updateTilesPlanDate(bucketDate, targetDate));
    }

    Swal.fire({
      title: 'Merge Tile Digest?',
      html: `${moment(targetDate, 'YYYY-MM-DD').format(
        'MMM Do',
      )} already has a tile digest with tiles.<br />Would you like to merge them together?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Merge Digest',
      confirmButtonColor: '#EC0404',
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        dispatch(updateTilesPlanDate(bucketDate, targetDate));
      }
    });
  };
};

export const removeDigest = bucketDate => {
  return (dispatch, getState) => {
    const {
      tiles: { buckets },
    } = getState();
    const bucketMonth = findBucketMonth(bucketDate);
    const updatedBuckets = updateBuckets(buckets, bucketMonth, bucketDate);

    return dispatch(setBuckets(updatedBuckets));
  };
};

export const deleteDigest = bucketDate => {
  return (dispatch, getState) => {
    const {
      tiles: { tiles },
      status: { activeStatus },
    } = getState();
    const currentTiles = tiles[activeStatus].tiles.filter(
      tile => tile.planDate === bucketDate,
    );
    const idsToChange = currentTiles.map(tile => tile.id);

    // don't prompt on empty digest
    if (currentTiles.length === 0) return dispatch(removeDigest(bucketDate));

    Swal.fire({
      title: 'Deleting a Digest can’t be undone',
      html: 'What would you like to do?',
      showCancelButton: true,
      confirmButtonText: 'Move Tiles back to Unscheduled',
      cancelButtonText: 'Delete Tiles',
      cancelButtonColor: '#ff5657',
      showCloseButton: true,
      reverseButtons: true,
      customClass: {
        title: 'delete-digest-modal-title',
        popup: 'delete-digest-modal-popup',
        content: 'delete-digest-modal-content',
        actions: 'delete-digest-modal-actions',
        confirmButton: 'delete-digest-modal-confirm-button',
        cancelButton: 'delete-digest-modal-cancel-button',
      },
    }).then(result => {
      if (result.value) {
        if (idsToChange.length > 0) {
          dispatch(updateTilesPlanDate(bucketDate, null));
        } else {
          dispatch(removeDigest(bucketDate));
        }
      }

      if (result.dismiss == 'cancel') {
        dispatch(deleteTiles(currentTiles, 'plan', bucketDate));
      }
    });
  };
};

export const generateBuckets = tiles => {
  return (dispatch, getState) => {
    const {
      tiles: { buckets },
    } = getState();
    let newBuckets = buckets;

    const digestsTiles = tiles.reduce((acc, tile) => {
      if (tile.planDate) {
        const date = moment(tile.planDate).format('YYYY-MM');
        acc[date] = acc[date] ? acc[date].concat(tile) : [tile];
      }
      return acc;
    }, {});

    const digests = Object.entries(digestsTiles).reduce((memo, digest) => {
      const [date, tilesInDigest] = digest;
      const tilesDigests = tilesInDigest.reduce((acc, tile) => {
        const { planDate } = tile;
        const digest = acc[planDate];
        if (digest) {
          acc[planDate] = { tiles: digest.tiles.concat(tile) };
        } else {
          acc[planDate] = { tiles: [tile] };
        }
        return acc;
      }, {});

      const digestMonth = {
        digests: tilesDigests,
        tileCount: tilesInDigest.length,
        digestCount: Object.keys(tilesDigests).length,
      };

      memo[date] = digestMonth;

      return memo;
    }, {});

    Object.entries(digests).forEach(digest => {
      const [date, attributes] = digest;

      if (newBuckets[date]) {
        newBuckets = update(newBuckets, {
          [date]: {
            $merge: attributes,
          },
        });
      }
    });

    dispatch(setBuckets(newBuckets));
  };
};

export const fetchNewTile = tileId => {
  return (dispatch, getState) => {
    const request = Fetcher.xmlHttpRequest({
      path: `/api/client_admin/tiles/${tileId}`,
      method: 'GET',
    });

    return request.then(response => {
      const { tiles } = getState();
      const { plan } = tiles.tiles;
      const updatedPlanTiles = update(plan, {
        tiles: {
          $unshift: [response],
        },
        count: {
          $set: plan.count + 1,
        },
      });
      const updatedTiles = update(tiles, {
        tiles: {
          $merge: {
            plan: updatedPlanTiles,
          },
        },
      });

      dispatch(setTiles(updatedTiles.tiles));
      dispatch(generateBuckets(updatedPlanTiles.tiles));
      dispatch(updateDragAndDropContext());
    });
  };
};

export const fetchTileData = tileId => {
  return (dispatch, getState) => {
    const {
      status: { activeStatus },
    } = getState();

    const request = Fetcher.xmlHttpRequest({
      path: `/api/client_admin/tiles/${tileId}`,
      method: 'GET',
    });

    return request.then(response => {
      dispatch(updateTile({ tile: response, activeStatus }));
      dispatch(updateDragAndDropContext());
    });
  };
};

export const deleteAudience = audience => {
  return dispatch => {
    dispatch(removeAudience(audience));

    const request = Fetcher.xmlHttpRequest({
      path: `/api/client_admin/audiences/${audience.value}`,
      method: 'DELETE',
    });

    return request;
  };
};

export const deleteTopic = topic => {
  return dispatch => {
    dispatch(removeTopic(topic));

    const request = Fetcher.xmlHttpRequest({
      path: `/api/v1/ribbon_tags/${topic.value}`,
      method: 'DELETE',
    });

    return request;
  };
};

export const fetchPopulationSegments = () => {
  return dispatch => {
    const request = Fetcher.xmlHttpRequest({
      path: '/api/client_admin/population_segments',
      method: 'GET',
    });

    return request.then(response => {
      dispatch(setPopulationSegments(response));
    });
  };
};

export const createAudience = data => {
  return dispatch => {
    const request = Fetcher.xmlHttpRequest({
      path: '/api/client_admin/audiences/',
      method: 'POST',
      params: data,
    });

    return request.then(response => {
      const sanitizeData = helper.sanitizeAudienceResponse(response);
      dispatch(addAudience(sanitizeData));
      dispatch(setAlert(null));
    });
  };
};

export const updateAudience = data => {
  return dispatch => {
    const request = Fetcher.xmlHttpRequest({
      path: `/api/client_admin/audiences/${data.id}`,
      method: 'PUT',
      params: data,
    });

    return request.then(response => {
      dispatch(removeAudience(data));
      const sanitizeData = helper.sanitizeAudienceResponse(response);
      dispatch(addAudience(sanitizeData));
      dispatch(setAlert(null));
    });
  };
};

export const createTopic = data => {
  return dispatch => {
    const request = Fetcher.xmlHttpRequest({
      path: '/api/v1/ribbon_tags/',
      method: 'POST',
      params: data,
    });

    return request.then(response => {
      dispatch(addTopic(response.ribbon_tag));
    });
  };
};

export const updateTopic = data => {
  return dispatch => {
    const request = Fetcher.xmlHttpRequest({
      path: `/api/v1/ribbon_tags/${data.id}`,
      method: 'PUT',
      params: data,
    });

    return request.then(response => {
      dispatch(removeTopic(data));
      dispatch(addTopic(response.ribbon_tag));
    });
  };
};

export const triggerDeleteAudienceModal = audience => {
  return dispatch => {
    const args = {
      customClass: 'airbo',
      cancelBtnCssClass: 'cancel',
      confirmBtnCssClass: 'delete_confirm',
      confirmBtnText: 'Delete',
      showCancel: true,
      style: {
        display: 'inherit',
        width: '520px',
      },
      title: "Deleting an Audience can't be undone",
      onCancel: () => {
        dispatch(setAlert(null));
      },
      onConfirm: () => {
        dispatch(deleteAudience(audience));
        dispatch(setAlert(null));
      },
    };
    const name = audience.label || audience.name;
    const alert = (
      <SweetAlert {...args}>
        Are you sure you want to delete <strong>{name}</strong> Audience?
      </SweetAlert>
    );

    dispatch(setAlert(alert));
  };
};

export const triggerDeleteTopicModal = topic => {
  return dispatch => {
    const args = {
      customClass: 'airbo',
      cancelBtnCssClass: 'cancel',
      confirmBtnCssClass: 'delete_confirm',
      confirmBtnText: 'Delete',
      showCancel: true,
      style: {
        display: 'inherit',
        width: '520px',
      },
      title: "Deleting a Topic can't be undone",
      onCancel: () => {
        dispatch(setAlert(null));
      },
      onConfirm: () => {
        if (topic.value) {
          dispatch(deleteTopic(topic));
        }
        dispatch(setAlert(null));
      },
    };
    const alert = (
      <SweetAlert {...args}>
        <DeleteTopicSubtitle>
          Are you sure you want to delete <strong>{topic.label}</strong> Topic?
          <br />
          This will remove it from any Tiles currently using it.
        </DeleteTopicSubtitle>
      </SweetAlert>
    );

    dispatch(setAlert(alert));
  };
};
